import { ComponentWithPermissions } from '../../../../../../../baseComponents/CreateRoutering/types'
import BaseScreenTable from '../../../../../../../baseComponents/TwinTable/BaseScreenTable'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import ModalCreateSellDeliveryNote from './ModalCreateSellDeliveryN'
import TableSellDeliveryNotes from '../../../../../../../specificComponents/sells/TableSellDeliveryNote'
import { Link } from 'react-router-dom'
import locations from '../../../../../../../utils/globals/locations'
import { ButtonSecondary } from '../../../../../../../baseComponents/Button'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'


interface SellDeliveryNotesProps extends ComponentWithPermissions { }

const SellDeliveryNotes: React.FC<SellDeliveryNotesProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()
    const pageData = {
        title: t('deliveryNotes', 'Albaranes'),
        newText: t('newdeliveryNote', 'Nuevo albarán'),
    }

    return (
        <BaseScreenTable TableComponent={TableSellDeliveryNotes} CreateModalComponent={ModalCreateSellDeliveryNote} pageData={pageData} userPermissions={userPermissions} RightHeader={<Link to={locations.sellDeliveryNoteMulti + '/main'} > <ButtonSecondary className='mr-10'><TwinTrans transKey='generateMultiDeliveryNote'> Generar albarán múltiple</TwinTrans></ButtonSecondary></Link >} />
    )
}

export default SellDeliveryNotes